import { useEffect, useState } from 'react';

// Worked out by the backend the first time a record is shown and kept on it;
// until then the greeting goes out without a name.
export default function useGreetingNames(record, fill) {
  const [filled, setFilled] = useState(null);
  const [error, setError] = useState('');
  const stored = record?.greeting_names;

  useEffect(() => {
    setFilled(null);
    setError('');
    if (!record || stored) return undefined;
    let cancelled = false;
    fill(record.id)
      .then((names) => { if (!cancelled) setFilled(names); })
      .catch((e) => { if (!cancelled) setError(e?.response?.data?.detail || e.message); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record?.id, record?.name, stored]);

  return { names: stored ?? filled, error };
}
